export const navCategories = [
  {
    id: 'yingshi',
    name: '影视视频',
    slug: 'yingshi',
    description: '电影、电视剧、综艺在线观看',
    icon: 'ri-movie-2-line',
    count: '3.2K+',
    color: 'from-rose-500/80 to-orange-500/80',
    sites: [
      { name: '爱奇艺', url: 'http://chiguadao.cn/', description: '高清视频在线观看平台' },
      { name: '腾讯视频', url: 'http://chiguadao.cn/', description: '热门综艺电视剧独播' },
      { name: '优酷', url: 'http://chiguadao.cn/', description: '海量影视资源平台' },
      { name: '哔哩哔哩', url: 'http://chiguadao.cn/', description: '弹幕视频分享网站' },
      { name: '芒果TV', url: 'http://chiguadao.cn/', description: '湖南卫视官方视频平台' },
      { name: '搜狐视频', url: 'http://chiguadao.cn/', description: '正版高清影视在线' },
    ],
  },
  {
    id: 'gouwu',
    name: '购物消费',
    slug: 'gouwu',
    description: '电商平台、比价购物一站搞定',
    icon: 'ri-shopping-cart-2-line',
    count: '5.1K+',
    color: 'from-emerald-500/80 to-teal-500/80',
    sites: [
      { name: '淘宝网', url: 'http://chiguadao.cn/', description: '阿里巴巴旗下电商平台' },
      { name: '京东商城', url: 'http://chiguadao.cn/', description: '正品保证极速物流' },
      { name: '拼多多', url: 'http://chiguadao.cn/', description: '实惠团购电商平台' },
      { name: '天猫', url: 'http://chiguadao.cn/', description: '品牌旗舰店购物平台' },
      { name: '唯品会', url: 'http://chiguadao.cn/', description: '品牌特卖折扣网站' },
      { name: '苏宁易购', url: 'http://chiguadao.cn/', description: '家电3C正品商城' },
    ],
  },
  {
    id: 'xinwen',
    name: '新闻资讯',
    slug: 'xinwen',
    description: '国内外新闻资讯实时掌握',
    icon: 'ri-newspaper-line',
    count: '2.8K+',
    color: 'from-sky-500/80 to-indigo-500/80',
    sites: [
      { name: '新浪新闻', url: 'http://chiguadao.cn/', description: '国内外热点新闻报道' },
      { name: '腾讯新闻', url: 'http://chiguadao.cn/', description: '综合资讯门户平台' },
      { name: '网易新闻', url: 'http://chiguadao.cn/', description: '有态度的新闻资讯' },
      { name: '今日头条', url: 'http://chiguadao.cn/', description: '个性化资讯推荐引擎' },
      { name: '澎湃新闻', url: 'http://chiguadao.cn/', description: '专注时政与深度报道' },
      { name: '凤凰网', url: 'http://chiguadao.cn/', description: '高端时政财经资讯' },
    ],
  },
  {
    id: 'shejiao',
    name: '社交社区',
    slug: 'shejiao',
    description: '社交网络、论坛社区互动交流',
    icon: 'ri-user-heart-line',
    count: '4.5K+',
    color: 'from-pink-500/80 to-rose-500/80',
    sites: [
      { name: '微博', url: 'http://chiguadao.cn/', description: '中国最大社交媒体平台' },
      { name: '知乎', url: 'http://chiguadao.cn/', description: '高质量问答社区' },
      { name: '豆瓣', url: 'http://chiguadao.cn/', description: '读书电影音乐社区' },
      { name: '小红书', url: 'http://chiguadao.cn/', description: '生活方式分享平台' },
      { name: '虎扑', url: 'http://chiguadao.cn/', description: '体育社区与赛事讨论' },
      { name: '贴吧', url: 'http://chiguadao.cn/', description: '百度兴趣主题社区' },
    ],
  },
  {
    id: 'sousuo',
    name: '搜索引擎',
    slug: 'sousuo',
    description: '主流搜索引擎入口汇总',
    icon: 'ri-search-eye-line',
    count: '1.2K+',
    color: 'from-amber-500/80 to-yellow-500/80',
    sites: [
      { name: '百度', url: 'http://chiguadao.cn/', description: '全球最大中文搜索引擎' },
      { name: '搜狗', url: 'http://chiguadao.cn/', description: '支持微信知乎搜索' },
      { name: '必应', url: 'http://chiguadao.cn/', description: '微软旗下国际搜索引擎' },
      { name: '360搜索', url: 'http://chiguadao.cn/', description: '安全绿色的搜索引擎' },
      { name: 'Google', url: 'http://chiguadao.cn/', description: '全球领先搜索引擎' },
      { name: '神马搜索', url: 'http://chiguadao.cn/', description: 'UC旗下移动搜索引擎' },
    ],
  },
  {
    id: 'gongju',
    name: '实用工具',
    slug: 'gongju',
    description: '在线工具、效率办公必备',
    icon: 'ri-tools-line',
    count: '3.7K+',
    color: 'from-violet-500/80 to-purple-500/80',
    sites: [
      { name: '百度网盘', url: 'http://chiguadao.cn/', description: '个人云存储服务' },
      { name: '石墨文档', url: 'http://chiguadao.cn/', description: '在线协作文档工具' },
      { name: 'WPS', url: 'http://chiguadao.cn/', description: '国产办公套件' },
      { name: '有道词典', url: 'http://chiguadao.cn/', description: '权威在线翻译工具' },
      { name: '腾讯会议', url: 'http://chiguadao.cn/', description: '高清视频会议工具' },
      { name: 'processon', url: 'http://chiguadao.cn/', description: '免费在线作图工具' },
    ],
  },
  {
    id: 'xuexi',
    name: '学习教育',
    slug: 'xuexi',
    description: '在线课程、知识付费平台',
    icon: 'ri-book-open-line',
    count: '2.4K+',
    color: 'from-cyan-500/80 to-blue-500/80',
    sites: [
      { name: '网易云课堂', url: 'http://chiguadao.cn/', description: '职业技能在线学习' },
      { name: '慕课网', url: 'http://chiguadao.cn/', description: 'IT技能学习平台' },
      { name: '中国大学MOOC', url: 'http://chiguadao.cn/', description: '国内高校课程平台' },
      { name: '学堂在线', url: 'http://chiguadao.cn/', description: '清华大学发起慕课平台' },
      { name: '得到', url: 'http://chiguadao.cn/', description: '知识服务与通识学习' },
      { name: '极客时间', url: 'http://chiguadao.cn/', description: 'IT技术知识付费平台' },
    ],
  },
  {
    id: 'shenghuo',
    name: '生活服务',
    slug: 'shenghuo',
    description: '吃喝玩乐、出行旅游指南',
    icon: 'ri-map-pin-line',
    count: '4.0K+',
    color: 'from-lime-500/80 to-green-500/80',
    sites: [
      { name: '美团', url: 'http://chiguadao.cn/', description: '吃喝玩乐一站搞定' },
      { name: '大众点评', url: 'http://chiguadao.cn/', description: '本地生活信息指南' },
      { name: '携程旅行', url: 'http://chiguadao.cn/', description: '机票酒店旅游预订' },
      { name: '饿了么', url: 'http://chiguadao.cn/', description: '外卖订餐即时配送' },
      { name: '滴滴出行', url: 'http://chiguadao.cn/', description: '一站式出行服务平台' },
      { name: '58同城', url: 'http://chiguadao.cn/', description: '本地生活分类信息' },
    ],
  },
  {
    id: 'yinyue',
    name: '音乐音频',
    slug: 'yinyue',
    description: '在线音乐、播客电台收听',
    icon: 'ri-music-line',
    count: '1.8K+',
    color: 'from-red-500/80 to-pink-500/80',
    sites: [
      { name: '网易云音乐', url: 'http://chiguadao.cn/', description: '音乐发现与分享平台' },
      { name: 'QQ音乐', url: 'http://chiguadao.cn/', description: '腾讯旗下正版音乐' },
      { name: '酷狗音乐', url: 'http://chiguadao.cn/', description: '老牌数字音乐平台' },
      { name: '喜马拉雅', url: 'http://chiguadao.cn/', description: '音频分享与收听平台' },
      { name: '蜻蜓FM', url: 'http://chiguadao.cn/', description: '网络收音机广播电台' },
      { name: '荔枝', url: 'http://chiguadao.cn/', description: '人人都是播客创作者' },
    ],
  },
];

export const hotSites = [
  { name: '百度', url: 'http://chiguadao.cn/', category: '搜索引擎', rating: '99%', icon: 'ri-global-line', rank: 1 },
  { name: '微博', url: 'http://chiguadao.cn/', category: '社交平台', rating: '98%', icon: 'ri-chat-smile-2-line', rank: 2 },
  { name: '哔哩哔哩', url: 'http://chiguadao.cn/', category: '视频平台', rating: '97%', icon: 'ri-tv-2-line', rank: 3 },
  { name: '知乎', url: 'http://chiguadao.cn/', category: '问答社区', rating: '96%', icon: 'ri-question-answer-line', rank: 4 },
  { name: '淘宝', url: 'http://chiguadao.cn/', category: '电商购物', rating: '97%', icon: 'ri-shopping-bag-3-line', rank: 5 },
  { name: '京东', url: 'http://chiguadao.cn/', category: '电商购物', rating: '96%', icon: 'ri-store-2-line', rank: 6 },
  { name: '抖音', url: 'http://chiguadao.cn/', category: '短视频', rating: '98%', icon: 'ri-tiktok-line', rank: 7 },
  { name: '网易云音乐', url: 'http://chiguadao.cn/', category: '音乐平台', rating: '95%', icon: 'ri-music-line', rank: 8 },
  { name: '腾讯视频', url: 'http://chiguadao.cn/', category: '视频平台', rating: '96%', icon: 'ri-movie-line', rank: 9 },
  { name: '小红书', url: 'http://chiguadao.cn/', category: '生活方式', rating: '95%', icon: 'ri-heart-line', rank: 10 },
  { name: '爱奇艺', url: 'http://chiguadao.cn/', category: '视频平台', rating: '95%', icon: 'ri-film-line', rank: 11 },
  { name: '拼多多', url: 'http://chiguadao.cn/', category: '电商购物', rating: '94%', icon: 'ri-price-tag-3-line', rank: 12 },
];